// Artifact pages are shared by Standard and AI Agent navigation. Carry the mode explicitly in
// their URLs so a full Rails navigation renders the same side-nav variant that launched them.
export function artifactModePath(path, mode) {
  if (mode !== "agent") return path
  return `${path}${path.includes("?") ? "&" : "?"}mode=agent`
}

export function artifactModeFromSearch(search) {
  try {
    return new URLSearchParams(search || "").get("mode") === "agent" ? "agent" : "standard"
  } catch (_e) {
    return "standard"
  }
}
